import API from "./API";

export default class Item extends API {
  constructor(gateway) {
    super(gateway, 'item')
  }

  SubCategory(selector) {
    let { subCategory, category, overallCategory, low, high } = selector

    if (this.IsOfflineReady())
      return this.DB().where("id")
        .between(low, high)
        .toArray()

    let filter = { }

    if (subCategory) filter.subCategoryFilter = subCategory
    if (overallCategory) filter.overallCategoryFilter = overallCategory
    if (category) filter.categoryFilter = category

    return this.invoke('', filter).then((results) => {
      return this.DB().bulkPut(results).then(added => results)
    })
  }

  Categories() {
    let localCategories = localStorage[`itemCategories`]
    if (localCategories)
      return Promise.resolve(JSON.parse(localCategories))

    return this.invoke('category').then(overallCategories => {

      Object.keys(overallCategories).forEach(overallCategoryName => {
        let overallCategory = overallCategories[overallCategoryName]
        Object.keys(overallCategory).forEach(categoryName => {
          overallCategory[categoryName] = overallCategory[categoryName].reduce((total, current) => {
            total[current.item1] = {
              low: current.item2,
              high: current.item3,
              subCategory: current.item1,
              category: categoryName,
              overallCategory: overallCategoryName
            }
            return total
          }, {})
        })
      })

      localStorage['itemCategories'] = JSON.stringify(overallCategories)
      return overallCategories
    })
  }
}